import { MouseEventHandler, useState } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { Formik, FormikProps, FormikErrors } from 'formik';
import AddIcon from '@mui/icons-material/Add';

import ModuleType from './models/ModuleType';
import React from 'react';

export interface Props {
  data: ModuleType;
  onInsert?: MouseEventHandler<HTMLButtonElement> | undefined;
  filtersForm?: ({ values }: FormikProps<any>) => JSX.Element | undefined;
  onFiltersChanged?: ((values: unknown) => void | object | Promise<FormikErrors<unknown>>) & ((values: unknown) => Promise<void>);
  filtersInitialValues?: unknown;
}

const ModuleNavBar = (props: Props) => {
  const { onInsert, filtersForm, onFiltersChanged, filtersInitialValues } = props;
  const { t } = useTranslation();

  const debounceTimespanMs = 500;

  let timeoutRef: string | number | NodeJS.Timeout;

  const initialValues = filtersInitialValues ? filtersInitialValues : {};

  const [filtersValues, setFiltersValues] = useState(initialValues);

  return (
    <div className="navbar">
      <div className="header">
        <div className="icon-title">
          {props.data.icon}

          {typeof props.data.title === "string" ?
            <h1>{props.data.title}</h1> : props.data.title}
        </div>

        {onInsert &&
          <Button
            variant="outlined"
            endIcon={<AddIcon />}
            onClick={onInsert}>
            {t('create')}
          </Button>}
      </div>

      <div className="filters">
        {filtersForm && (
          <Formik
            onSubmit={(values) => { console.log(values); }}
            initialValues={initialValues}
            validateOnChange
            validate={async (values: any) => {
              if (onFiltersChanged && JSON.stringify(filtersValues) !== JSON.stringify(values)) {
                if (timeoutRef)
                  clearTimeout(timeoutRef);

                timeoutRef = setTimeout(async () => {
                  await onFiltersChanged(values);
                  setFiltersValues(values);
                  timeoutRef = -1;
                }, debounceTimespanMs);
              }
            }}>
            {filtersForm}
          </Formik>)}
      </div>
    </div>
  );
};

export default ModuleNavBar;
